import React from 'react'
    import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
    import { Toaster } from 'react-hot-toast'
    import Navbar from './components/Navbar'
    import Home from './pages/Home'
    import Services from './pages/Menu'
    import Contact from './pages/Contact'
    import Footer from './components/Footer'

    function App() {
      return (
        <div data-component-path="client/src/App.jsx" data-component-line="1:4" data-component-id="client/src/App.jsx:1:4" className="min-h-screen bg-white">
          <Router>
            <Navbar />
            <main data-component-path="client/src/App.jsx" data-component-line="2:6" data-component-id="client/src/App.jsx:2:6">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/menu" element={<Services />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-right" />
          </Router>
        </div>
      )
    }

    export default App